<template>
  <Transition name="nested" duration="500">
    <div v-if="showSidebar" class="fixed top-0 left-0 w-full h-full z-[60] transition-all duration-500 delay-500">
      <div class="bg-ip-color-3 px-4 pb-4 sidebar-height w-full h-full overflow-clip">
        <div class="relative w-full h-full space-y-10">
          <div class="text-white flex items-center justify-between w-full py-5 md:py-[3vw] lg:py-[1.3vw]">
          <MainLogo class="max-w-[9rem]"/>
            <button @click="toggleShowSidebar">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
          <div class="space-y-6">
            <div v-for="item in menus" :key="item.id" class="menu-links flex justify-center items-center opacity-0">
              <NuxtLink v-if="item.type == 'link'" :to="({name: item.path})" @click="toggleShowSidebar" class="text-3xl block figtree relative w-fit overflow-clip group pb-1 text-white">
                <span class="whitespace-nowrap figtree font-semibold">{{ item.name[locale] }}</span>
                <div class="absolute w-full border-t-2 border-white bottom-0 -translate-x-[102%] group-hover:translate-x-0 transition-transform duration-300"></div>
              </NuxtLink>
              <button v-else @click="item.function()" class="text-3xl block figtree relative w-fit overflow-clip group pb-1 text-white">
                <span class="whitespace-nowrap figtree font-semibold">{{ item.name[locale] }}</span>
                <div class="absolute w-full border-t-2 border-white bottom-0 -translate-x-[102%] group-hover:translate-x-0 transition-transform duration-300"></div>
              </button>
            </div>
          </div>
        </div>
        <div class="absolute bottom-0 left-0 opacity-5 w-48 h-48">
          <VectorSingleArrow color="ip-color-10" class="sidebar-arrow opacity-0"/>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
 
 
const locale = ref('en')
const navbarStore = useNavbarStore();
 
const { $anime } = useNuxtApp();

const emits = defineEmits(['close']);

const showSidebar = computed(() => navbarStore.$state.showSideBar);
const toggleShowSidebar = async () => {
  emits('close');
  navbarStore.closeSidebar();
};

const downloadCta = ref({
  titleText: {
    id: 'Transportasi Cepat Tanpa Stop',
    en: 'Fast Without Stop',
  },
  subtitleText: {
    id: 'Download dan daftar aplikasi Cantas melalui link di bawah ini.',
    en: 'Download and register Cantas application, use the link below.',
  },
});

const menus = ref([
  {
    path: 'index',
    sort: 0,
    visible: true,
    name: {
      id: 'Home',
      en: 'Home',
    },
    type: 'link',
  },
  {
    path: 'about-us',
    sort: 1,
    visible: true,
    name: {
      id: 'About Us',
      en: 'About Us',
    },
    type: 'link',
  },
  {
    path: 'our-services',
    sort: 2,
    visible: true,
    name: {
      id: 'Our Services',
      en: 'Our Services',
    },
    type: 'link',
  },
  {
    path: 'insights',
    sort: 3,
    visible: true,
    name: {
      id: 'Insights',
      en: 'Insights',
    },
    type: 'link',
  },
  {
    path: 'contact-us',
    sort: 4,
    visible: true,
    name: {
      id: 'Contact Us',
      en: 'Contact Us',
    },
    type: 'button',
    function: () => {
      toggleShowSidebar();
      const to = setTimeout(() => {
        navbarStore.toggleContact();
        clearTimeout(to);
      }, 300);
    },
  },

]);

watch(() => showSidebar.value,
  val => {
    if (val) {
      const to = setTimeout(() => {
        $anime({
          targets: '.menu-links',
          opacity: 1,
          translateY: [20, 0],
          delay: $anime.stagger(50),
          duration: 1000,
          easing: 'easeOutExpo',
        });
        $anime({
          targets: '.sidebar-arrow',
          opacity: [0, 1],
          translateY: [20, 0],
          translateX: [-20, 0],
          duration: 2000,
          easing: 'easeOutExpo',
        });
        clearTimeout(to);
      }, 300);
    }
  },
);

</script>

<style lang="scss" scoped>

.router-link-exact-active{
  .active-link{
    @apply translate-x-0 #{!important};
  }
}
</style>
